// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://gnosisscan.io/address/0x36616cf17557639614c1cdDb356b1B83fc0B2132
export const POOL_ADDRESSES_PROVIDER = '0x36616cf17557639614c1cdDb356b1B83fc0B2132';

// IPool https://gnosisscan.io/address/0xb50201558B00496A145fE76f7424749556E326D8
export const POOL = '0xb50201558B00496A145fE76f7424749556E326D8';

// IPoolConfigurator https://gnosisscan.io/address/0x7304979ec9E4EaA0273b6A037a31c4e9e5A75D16
export const POOL_CONFIGURATOR = '0x7304979ec9E4EaA0273b6A037a31c4e9e5A75D16';

// IAaveOracle https://gnosisscan.io/address/0xeb0a051be10228213BAEb449db63719d6742F7c4
export const ORACLE = '0xeb0a051be10228213BAEb449db63719d6742F7c4';

// https://gnosisscan.io/address/0x1dF462e2712496373A347f8ad10802a5E95f053D
export const ACL_ADMIN = '0x1dF462e2712496373A347f8ad10802a5E95f053D';

// IACLManager https://gnosisscan.io/address/0xEc710f59005f48703908bC519D552Df5B8472614
export const ACL_MANAGER = '0xEc710f59005f48703908bC519D552Df5B8472614';

// IPoolDataProvider https://gnosisscan.io/address/0xF1F5acB596568895393cB5E4D0452D6592A2fA70
export const AAVE_PROTOCOL_DATA_PROVIDER = '0xF1F5acB596568895393cB5E4D0452D6592A2fA70';

// https://gnosisscan.io/address/0xD995db296E5Fe4268fcE5F4D8D2d25817C7c20Bc
export const POOL_IMPL = '0xD995db296E5Fe4268fcE5F4D8D2d25817C7c20Bc';

// https://gnosisscan.io/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://gnosisscan.io/address/0xaD4F91D26254B6B0C6346b390dDA2991FDE2F20d
export const DEFAULT_INCENTIVES_CONTROLLER = '0xaD4F91D26254B6B0C6346b390dDA2991FDE2F20d';

// https://gnosisscan.io/address/0x41585C50524fb8c3899B43D7D797d9486AAc94DB
export const EMISSION_MANAGER = '0x41585C50524fb8c3899B43D7D797d9486AAc94DB';

// ICollector https://gnosisscan.io/address/0x3e652E97ff339B73421f824F5b03d75b62F1Fb51
export const COLLECTOR = '0x3e652E97ff339B73421f824F5b03d75b62F1Fb51';

// https://gnosisscan.io/address/0xCE579ae642E40F8356a9f538c6dB4E2Ea91C5850
export const DEFAULT_A_TOKEN_IMPL = '0xCE579ae642E40F8356a9f538c6dB4E2Ea91C5850';

// https://gnosisscan.io/address/0xaE34350Ba3DE25CEEb9cE718f12DA4c26D6d4F71
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0xaE34350Ba3DE25CEEb9cE718f12DA4c26D6d4F71';

// https://gnosisscan.io/address/0x984B710D22730f799312513A10C1382e9D1Fa689
export const CONFIG_ENGINE = '0x984B710D22730f799312513A10C1382e9D1Fa689';

// https://gnosisscan.io/address/0x1236010CECea55998384e795B59815D871f5f94d
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x1236010CECea55998384e795B59815D871f5f94d';

// https://gnosisscan.io/address/0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16
export const UI_INCENTIVE_DATA_PROVIDER = '0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16';

// https://gnosisscan.io/address/0xD14F4d3495d5096a31F33605F2D0803bbe2EAdc0
export const UI_POOL_DATA_PROVIDER = '0xD14F4d3495d5096a31F33605F2D0803bbe2EAdc0';

// https://gnosisscan.io/address/0x4172E6aAEC070ACB31aaCE343A58c93E4C70f44D
export const WALLET_BALANCE_PROVIDER = '0x4172E6aAEC070ACB31aaCE343A58c93E4C70f44D';

// https://gnosisscan.io/address/0x721B9abAb6511b46b9ee83A1aba23BDAcB004149
export const WETH_GATEWAY = '0x721B9abAb6511b46b9ee83A1aba23BDAcB004149';

// https://gnosisscan.io/address/0x1AA25FdD7d55FA8a401D6EFba8e48874Ef730E55
export const RISK_STEWARD = '0x1AA25FdD7d55FA8a401D6EFba8e48874Ef730E55';

// https://gnosisscan.io/address/0x02e9b27599C4Bf8f789d34b6E65C51092c3d9FA6
export const LEGACY_STATIC_A_TOKEN_FACTORY = '0x02e9b27599C4Bf8f789d34b6E65C51092c3d9FA6';

// https://gnosisscan.io/address/0x33992721c565dA3248bd3af80524e054F5F05b42
export const STATA_FACTORY = '0x33992721c565dA3248bd3af80524e054F5F05b42';

// https://gnosisscan.io/address/0x86b0521f92a554057e54B93098BA2A6Aaa2F4ACB
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x86b0521f92a554057e54B93098BA2A6Aaa2F4ACB';

// https://gnosisscan.io/address/0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4
export const SWAP_COLLATERAL_ADAPTER = '0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4';

// https://gnosisscan.io/address/0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034
export const DEBT_SWAP_ADAPTER = '0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034';

// https://gnosisscan.io/address/0xc0179321f0825c3e0F59Fe7Ca4E40557b97797a3
export const WITHDRAW_SWAP_ADAPTER = '0xc0179321f0825c3e0F59Fe7Ca4E40557b97797a3';

// https://gnosisscan.io/address/0xFf3a13703236A77Da603c7D413cf6F6AfB866D34
export const DUST_BIN = '0xFf3a13703236A77Da603c7D413cf6F6AfB866D34';

// https://gnosisscan.io/address/0x0447Be151c126D2d704b1Ce5F5b3ed6b7D50FABA
export const CLINIC_STEWARD = '0x0447Be151c126D2d704b1Ce5F5b3ed6b7D50FABA';

// https://gnosisscan.io/address/0xdA12A8F009258592A9B5618129259992858636dc
export const POOL_EXPOSURE_STEWARD = '0xdA12A8F009258592A9B5618129259992858636dc';

// https://gnosisscan.io/address/0x7BD97DD6C199532d11Cf5f55E13a120dB6dd0F4F
export const EDGE_RISK_ORACLE = '0x7BD97DD6C199532d11Cf5f55E13a120dB6dd0F4F';

// https://gnosisscan.io/address/0x655252250f4A453854040A49E8280951A76f3033
export const EDGE_RISK_STEWARD_CAPS = '0x655252250f4A453854040A49E8280951A76f3033';

// https://gnosisscan.io/address/0x394aDC8772DDD076BD3c5C545c4Edd3617C7d5e6
export const EDGE_INJECTOR_CAPS = '0x394aDC8772DDD076BD3c5C545c4Edd3617C7d5e6';

export const CHAIN_ID = 100;
export const ASSETS = {
  WETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1',
    A_TOKEN: '0xa818F1B57c201E092C4A2017A91815034326Efd1',
    V_TOKEN: '0x0c0fce05F2314540EcB095bF4D069e5E0ED90fF8',
    INTEREST_RATE_STRATEGY: '0x4cE496f0a390745102540faF041EF92FfD588b44',
    ORACLE: '0xa767f745331D267c7751297D982b050c93985627',
    STATIC_A_TOKEN: '0xD843FB478c5aA9759FeA3f3c98D467e2F136190a',
    STATA_TOKEN: '0x57f664882F762FA37903FC864e2B633D384B411A',
  },
  wstETH: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6',
    A_TOKEN: '0x23e4E76D01B2002BE436CE8d6044b0aA2f68B68a',
    V_TOKEN: '0x9D881f67F20B49243c98f53d2B9E91E39d02Ae09',
    INTEREST_RATE_STRATEGY: '0x4cE496f0a390745102540faF041EF92FfD588b44',
    ORACLE: '0x8Ee42Ba520cA106294163fb8b1ffE9C6Fba35507',
    STATIC_A_TOKEN: '0xECfD0638175e291BA3F784A58FB9D38a25418904',
    STATA_TOKEN: '0x773CDA0CADe2A3d86E6D4e30699d40bB95174ff2',
  },
  GNO: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb',
    A_TOKEN: '0xA1Fa064A85266E2Ca82DEe5C5CcEC84DF445760e',
    V_TOKEN: '0xBc59E99198DbA71985A66E1713cC89FFEC53f7FC',
    INTEREST_RATE_STRATEGY: '0x4cE496f0a390745102540faF041EF92FfD588b44',
    ORACLE: '0x22441d81416430A54336aB28765abd31a792Ad37',
    STATIC_A_TOKEN: '0x2D737e2B0e175f05D0904C208d6C4e40da570f65',
    STATA_TOKEN: '0x7c16F0185A26Db0AE7a9377f23BC18ea7ce5d644',
  },
  USDC: {
    decimals: 6,
    id: 3,
    UNDERLYING: '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
    A_TOKEN: '0xc6B7AcA6DE8a6044E0e32d0c841a89244A10D284',
    V_TOKEN: '0x5F6f7B0a87CA3CF3d0b431Ae03EF3305180BFf4d',
    INTEREST_RATE_STRATEGY: '0x4cE496f0a390745102540faF041EF92FfD588b44',
    ORACLE: '0x1450C4BE9dd66889CddAB77e5947B6166ACbfAE2',
    STATIC_A_TOKEN: '0x270bA1f35D8b87510D24F693fcCc0da02e6E4EeB',
  },
  WXDAI: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d',
    A_TOKEN: '0xd0Dd6cEF72143E22cCED4867eb0d5F2328715533',
    V_TOKEN: '0x281963D7471eCdC3A2Bd4503e24e89691cfe420D',
    INTEREST_RATE_STRATEGY: '0x4cE496f0a390745102540faF041EF92FfD588b44',
    ORACLE: '0x7443afE82986d7475Cea0c5b04C6F1581fdAce87',
    STATIC_A_TOKEN: '0x7f0EAE87Df30C468E0680c83549D0b3DE7664D4B',
  },
  EURe: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0xcB444e90D8198415266c6a2724b7900fb12FC56E',
    A_TOKEN: '0xEdBC7449a9b594CA4E053D9737EC5Dc4CbCcBfb2',
    V_TOKEN: '0xb96404e475f337A7E98e4a541C9b71309BB66c5A',
    INTEREST_RATE_STRATEGY: '0x4cE496f0a390745102540faF041EF92FfD588b44',
    ORACLE: '0xab70BCB260073d036d1660201e9d5405F5829b7a',
    STATIC_A_TOKEN: '0x8418D17640a74F1614AC3E1826F29e78714488a1',
    STATA_TOKEN: '0x417bc5b940475203A18C2f320a5ba470D6c5E463',
  },
  sDAI: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0xaf204776c7245bF4147c2612BF6e5972Ee483701',
    A_TOKEN: '0x7a5c3860a77a8DC1b225BD46d0fb2ac1C6D191BC',
    V_TOKEN: '0x8Fe06E1D8Aff42Bf6812CacF7854A2249a00bED7',
    INTEREST_RATE_STRATEGY: '0x4cE496f0a390745102540faF041EF92FfD588b44',
    ORACLE: '0x620424f393dD413c2F8Dc2980905c4daa3619e61',
    STATIC_A_TOKEN: '0xf3f45960f8dE00D8ED614D445a5a268c6F6Dec4f',
  },
  USDCe: {
    decimals: 6,
    id: 7,
    UNDERLYING: '0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0',
    A_TOKEN: '0xC0333cb85B59a788d8C7CAe5e1Fd6E229A3E5a65',
    V_TOKEN: '0x37B9Ad6b5DC8Ad977AD716e92F49e9D200e58431',
    INTEREST_RATE_STRATEGY: '0x4cE496f0a390745102540faF041EF92FfD588b44',
    ORACLE: '0x1450C4BE9dd66889CddAB77e5947B6166ACbfAE2',
    STATIC_A_TOKEN: '0xf0E7eC247b918311afa054E0AEdb99d74c31b809',
    STATA_TOKEN: '0x51350d88c1bd32Cc6A79368c9Fb70373Fb71F375',
  },
  GHO: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73',
    A_TOKEN: '0x3FdCeC11B4f15C79d483Aedc56F37D302837Cf4d',
    V_TOKEN: '0x2766EEFE0311Bf7421cC30155b03d210BCE30dF8',
    INTEREST_RATE_STRATEGY: '0x4cE496f0a390745102540faF041EF92FfD588b44',
    ORACLE: '0x360d8aa8F6b09B7BC57aF34db2Eb84dD87bf4d12',
    STATA_TOKEN: '0x58d9AcAC48A4077E4909181c48DEcD00E5ba5DE4',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'WETH,wstETH / WETH',
    collateralBitmap: '3',
    collateralAssets: [
      '0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1',
      '0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6',
    ],
    borrowableBitmap: '1',
    borrowableAssets: ['0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9300,
    liquidationBonus: 10100,
  },
  '2': {
    label: 'sDAI / EURe',
    collateralBitmap: '64',
    collateralAssets: ['0xaf204776c7245bF4147c2612BF6e5972Ee483701'],
    borrowableBitmap: '32',
    borrowableAssets: ['0xcB444e90D8198415266c6a2724b7900fb12FC56E'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8500,
    liquidationThreshold: 8750,
    liquidationBonus: 10500,
  },
  '3': {
    label: 'sDAI / USDCe',
    collateralBitmap: '64',
    collateralAssets: ['0xaf204776c7245bF4147c2612BF6e5972Ee483701'],
    borrowableBitmap: '128',
    borrowableAssets: ['0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10400,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
